export default __webpack_public_path__ + "static/media/eth.4ef7eab2.webp";